import { apiUrl } from './api_config'

const ANALYTICS_BASE_URL = apiUrl('/analytics')

async function request(url, options = {}) {
  const response = await fetch(url, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
  })

  let payload = null
  try {
    payload = await response.json()
  } catch {
    // Preserve the HTTP error when the response has no JSON body.
  }

  if (!response.ok) {
    throw new Error(
      payload?.message ||
        payload?.error ||
        `Analytics request failed (${response.status})`,
    )
  }

  return payload?.data || payload
}

export function getManagerAnalytics(
  { fromDate = '', toDate = '', orderType = '', dormantDays = '' } = {},
  signal,
) {
  const params = new URLSearchParams()
  if (fromDate) params.set('from_date', fromDate)
  if (toDate) params.set('to_date', toDate)
  if (orderType) params.set('order_type', orderType)
  if (dormantDays) params.set('dormant_days', String(dormantDays))
  const query = params.toString()
  return request(`${ANALYTICS_BASE_URL}/manager${query ? `?${query}` : ''}`, {
    signal,
  })
}

export function getSalesTargets(period, signal) {
  return request(
    `${ANALYTICS_BASE_URL}/targets?period=${encodeURIComponent(period)}`,
    { signal },
  )
}

export function saveSalesTargets(period, targets) {
  return request(`${ANALYTICS_BASE_URL}/targets`, {
    method: 'PUT',
    body: JSON.stringify({ period, targets }),
  })
}
